import { Component, OnDestroy, OnInit } from '@angular/core';
import { PersonaService } from 'src/app/services/persona/persona.service';
import { LoaderService } from 'src/app/services/interceptor/loader.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { getUserProfile, getUserProfiles } from 'src/app/core/session';
@Component({
  selector: 'app-add-bank-account',
  templateUrl: './add-bank-account.component.html',
  styleUrls: ['./add-bank-account.component.scss']
})
export class AddBankAccountComponent implements OnInit, OnDestroy {

  userProfileData = localStorage.getItem('userProfileData') ? getUserProfile() : {};
  user_subscription: Subscription;

  constructor(
    public _persona: PersonaService,
    public _auth: AuthService,
    public loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.user_subscription = this._auth.userProfileData$.subscribe(data => {
      this.userProfileData = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile();
    })
  }

  ngOnDestroy() {
    this.user_subscription && this.user_subscription.unsubscribe();
  }

}
